export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5046.e62dc13b.jpg";